import settings from "../utils/settings";
import SFError from "../models/SfError";
const useSendMemberOnboardSMS = () => {
  const sendSMS = async (phone) => {
    const { realmId, branchId, token } = settings();
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/onboard/subscribe/url/send`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            phone: phone + "|TH|+66",
            realm_id: realmId,
            branch_id: branchId,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return error.json();
      }
      const jsonResult = await result.json();
      return [jsonResult, null];
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError.json()];
    }
  };
  return { sendSMS };
};

export default useSendMemberOnboardSMS;
